import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Message from '../components/LoadingError/Error';
import Loading from '../components/LoadingError/Loading';
import { findPreorder, updatePreorder } from '../service/OrdersService';

const ShippingScreen = ({ user }) => {
  const [deliveryAddress, setDeliveryAddress] = useState({
    address: '',
    flat: '',
    city: '',
    postalCode: '',
    country: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const navigate = useNavigate();
  const params = useParams();
  const preorderId = params.id;

  useEffect(() => {
    if (user) {
      findPreorder(preorderId).then((preorder) => {
        if (preorder[0]?.deliveryAddress)
          setDeliveryAddress({
            address: preorder[0].deliveryAddress.address,
            flat: preorder[0].deliveryAddress.flat,
            city: preorder[0].deliveryAddress.city,
            postalCode: preorder[0].deliveryAddress.postalCode,
            country: preorder[0].deliveryAddress.country,
          });
        else {
          setDeliveryAddress({
            address: user.address,
            flat: user.flat,
            city: user.city,
            postalCode: user.zipCode,
            country: user.country,
          });
        }
        setLoading(false);
      });
    }
  }, [user, preorderId]);

  const handleAddress = (e) => {
    setDeliveryAddress({ ...deliveryAddress, [e.name]: e.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    updatePreorder({ deliveryAddress: deliveryAddress }, preorderId)
      .then(() => navigate(`/payment/${preorderId}`))
      .catch((error) => setError(error.response.data.message));
  };
  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex justify-content-center align-items-center mt-md-5'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <form
            className='Login col-md-8 col-lg-6 col-11'
            onSubmit={submitHandler}
          >
            <h6>DIRECCIÓN DE ENVÍO</h6>
            <input
              type='text'
              placeholder='Introducir la dirección'
              value={deliveryAddress.address}
              name='address'
              required
              onChange={(e) => handleAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir el piso'
              value={deliveryAddress.flat}
              name='flat'
              required
              onChange={(e) => handleAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir la ciudad'
              value={deliveryAddress.city}
              name='city'
              required
              onChange={(e) => handleAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir el código postal'
              value={deliveryAddress.postalCode}
              name='postalCode'
              required
              onChange={(e) => handleAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir el país'
              value={deliveryAddress.country}
              name='country'
              required
              onChange={(e) => handleAddress(e.target)}
            />
            <button
              disabled={
                !deliveryAddress.address?.length > 0 ||
                !deliveryAddress.flat?.length > 0 ||
                !deliveryAddress.city?.length > 0 ||
                !deliveryAddress.postalCode?.length > 0 ||
                !deliveryAddress.country
              }
              style={{
                backgroundColor:
                  (!deliveryAddress.address?.length > 0 ||
                    !deliveryAddress.flat?.length > 0 ||
                    !deliveryAddress.city?.length > 0 ||
                    !deliveryAddress.postalCode?.length > 0 ||
                    !deliveryAddress.country?.length > 0) &&
                  'grey',
              }}
              type='submit'
            >
              Continuar
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default ShippingScreen;
